module.exports = __webpack_public_path__ + "img/eum.7f6291d4.svg";